import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-editar-operacion-cuenta',
  templateUrl: './editar-operacion-cuenta.component.html',
  styleUrls: ['./editar-operacion-cuenta.component.scss']
})
export class EditarOperacionCuentaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
